var isMobile = document.documentElement.getAttribute('data-is-mobile') === 'true';
var bannerCount = document.documentElement.getAttribute('banner-count');

var hero_banner_nav = new Swiper(".banner-swiper-nav", {
    slidesPerView: bannerCount,
});
// Home Banner Slider
var swiper = new Swiper(".idx-banner .hero-banner-slider", {
    loop: true,
    effect: 'coverflow',
    coverflow: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 3,
        slideShadows : false
    },
    // Enable lazy loading
    preloadImages: false,
    // lazy: true,
    watchSlidesVisibility: true,  
    // lazyLoadingInPrevNext: true,
    lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
    },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".idx-banner .hero-banner-slider ~ .swiper-pagination",
        clickable: true,
    },  
    thumbs: {
        swiper: hero_banner_nav,
    },
});

// MsPuiyi Home Banner Slider
var swiper = new Swiper(".idx-banner-mspuiyi .hero-banner-slider", {
    loop: true,
    effect: 'coverflow',
    coverflow: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 3,
        slideShadows : false
    },
    // Enable lazy loading
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true
    },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".idx-banner-mspuiyi .hero-banner-slider ~ .swiper-pagination",
        clickable: true,
    },
});

// Jackpot Counter
var d = new Date; d = d.toLocaleTimeString(), strDate = d, arr = strDate.split(":");
var rightNow = new Date, res = rightNow.toISOString().slice(8, 10).replace(/-/g, "");
if(document.getElementById("odometer")){
res = 22 * res / 2,
    hour = parseInt(arr[0]),
    min = parseInt(arr[1]),
    hour < 10 ? hour = "0" + hour : hour,
    min < 10 ? min = "0" + min : min,
    ds = Number(res + "" + hour + min),
    ds *= 1.18,
    ds = ds.toFixed(2),
    document.getElementById("odometer").textContent = ds;
    var random = (.4 * Math.random() + .1).toFixed(2),
    counters = Number(document.getElementById("odometer").innerHTML).toFixed(2);

    setInterval(function () {
        counters = Number(counters) + Number(random),
            formatted = counters.toFixed(2).replace(/(\d)(?=(\d{3})+\.\d\d$)/g, "$1,"),
            document.getElementById("odometer").textContent = formatted
    }, 8000)
};

//Promotion
var promo_content = getPromoContents;
if ( Object.keys(promo_content).length > 0 && !isMobile ) 
{
    var swiperPromo = new Swiper(".idx-promotion .swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        breakpoints: 
        {  
            '1280': 
            {
              spaceBetween: 20,
            }
        },
    }).on('transitionEnd', function () {
        // Change Promotion Content when on slide
        var dataId = $('.swiper-slide-active').find('.picture').attr('data-id');  
        get_promotion_content(dataId);
    });
    // Inti Promotion Content
    var dataId = $('.swiper-slide-active').find('.picture').attr('data-id');  
    get_promotion_content(dataId);
    function get_promotion_content(dataId)
    {
        $('.promotion-article .title').text(promo_content[dataId]['name']);
        $('.promotion-article .description').text(promo_content[dataId]['sub_content']);
        $('.promotion-article button[name="infoBtn"]').attr('data-id', promo_content[dataId]['id']);
    }
    // Show more content
    $("[name=infoBtn]").on('click', function(e){
        e.preventDefault();
        var promotion_id = $(this).attr('data-id'); 
        $('#infoTitle').text(promo_content[promotion_id].name);
        $("#infoContent").html(promo_content[promotion_id].content);
    
        $("#infoModal").modal('show');
    });
}

//Feature
var swiperPromo = new Swiper(".idx-feature .feature-swiper", {
    slidesPerView: "auto",
    spaceBetween: 15,
    loop: true,
    pagination: {
        el: ".idx-feature .feature-swiper-navigation",
        clickable: true,
    },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    breakpoints: 
    {  
        '1280': 
        {
          spaceBetween: 30,
        }
    },
});


//Popular Game
var swiperPromo = new Swiper(".idx-popular-games .popular-games-swiper", {
    watchOverflow: true,
    loop: $(".popular-games-swiper .swiper-slide").length != 1,
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true
    },
    navigation: {
        nextEl: ".popular-games-navigator .next",
        prevEl: ".popular-games-navigator .prev",
    },
});


// Event
var swiperEvent = new Swiper(".event-banner-slider", {
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true
    },
    pagination: {
        el: ".event-banner-slider ~ .swiper-pagination",
        clickable: true,
    }, 
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
});

// Home Winner Slider
var swiper = new Swiper(".winner-swiper", {
    loop: true,
    autoplay: {
        delay: 1,
        disableOnInteraction: false
    },
    speed: 2000,
    slidesPerView: 'auto',
    // Enable lazy loading
    freeMode: true,
    preloadImages: false,
    spaceBetween: 15,
    // lazy: true,
    watchSlidesVisibility: true,  
    // lazyLoadingInPrevNext: true,
    lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
    },
});